(function () {
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function renderInto(container, products, cartItemIds) {
    var limit = parseInt(container.dataset.limit) || 4;
    var title = container.dataset.title || 'You may also like';

    var filtered = (products || []).filter(function (p) {
      return cartItemIds.indexOf(p.id) === -1 && p.available;
    }).slice(0, limit);

    if (!filtered.length) { container.innerHTML = ''; return; }

    var items = filtered.map(function (p) {
      var img = p.featured_image
        ? '<img src="' + p.featured_image + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" loading="lazy" width="56" height="56">'
        : '';
      return '<a href="' + p.url + '" class="td-cart-recs__item">'
        + '<div class="td-cart-recs__image">' + img + '</div>'
        + '<div class="td-cart-recs__info">'
        + '<p class="td-cart-recs__name">' + p.title + '</p>'
        + '<p class="td-cart-recs__price">' + formatMoney(p.price) + '</p>'
        + '</div></a>';
    }).join('');

    container.innerHTML = '<p class="td-cart-recs__title">' + title + '</p>'
      + '<div class="td-cart-recs__list">' + items + '</div>';
  }

  // Simple cache: productId → products[]
  var recsCache = {};

  function applyToContainers(cart) {
    if (!cart || !cart.items || !cart.items.length) return;

    var containers = document.querySelectorAll('[data-td-cart-recs]');
    if (!containers.length) return;

    var productId = cart.items[0].product_id;
    var cartItemIds = cart.items.map(function (i) { return i.product_id; });

    var maxLimit = 4;
    containers.forEach(function (c) {
      var l = parseInt(c.dataset.limit) || 4;
      if (l > maxLimit) maxLimit = l;
    });

    function doRender(products) {
      // Re-query each time — DOM may have been replaced by cart drawer refresh
      document.querySelectorAll('[data-td-cart-recs]').forEach(function (c) {
        renderInto(c, products, cartItemIds);
      });
    }

    if (recsCache[productId]) {
      doRender(recsCache[productId]);
      return;
    }

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=' + (maxLimit + 4) + '&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        recsCache[productId] = data.products || [];
        doRender(recsCache[productId]);
      })
      .catch(function () {});
  }

  // After Prestige replaces cart drawer DOM, re-render recs into the fresh node
  document.addEventListener('cart-drawer:refreshed', function () {
    recsCache = {}; // fresh DOM, bust cache so limit changes take effect
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(applyToContainers)
      .catch(function () {});
  });

  // cart:change covers the cart page recs (cart page reloads anyway, but
  // this also fires during quantity changes with the cart data inline)
  document.addEventListener('cart:change', function (e) {
    if (e.detail && e.detail.cart) applyToContainers(e.detail.cart);
  });

  // Initial page load
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(applyToContainers)
    .catch(function () {});
})();
